import React from 'react';
import('./style.scss');
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Stack from 'react-bootstrap/Stack';
import { Button } from 'primereact/button';
import PhotoCarousel from './PhotoCarousel';

const Home = () => {
  return (
    <>
      <div
        id='jumbotron'
        className='d-flex container-fluid justify-content-center align-items-center text-center'
      >
        <div className='contrast-box text-white p-4 px-sm-5'>
          <h1 className='pb-3 jumbotron-title'>
            <span>Young Israel</span> <span>of</span> <span>St. Louis</span>
          </h1>
          <h2 className='mb-0'>A Vibrant Modern Orthodox Shul</h2>
        </div>
      </div>

      <section className='home-section py-5'>
        <Container>
          <Row className='justify-content-center text-center'>
            <Col lg={8}>
              <h2 className='fw-bold mb-3'>Welcome to Young Israel</h2>
              <p className='lead'>
                We are a warm, Modern Orthodox community committed to daily tefillah,
                inspiring Torah learning, and genuine chesed. Whether you are looking
                for a place to daven, to learn, or to build lifelong friendships,
                you will find a home with us.
              </p>
              <Stack
                direction='horizontal'
                className='flex-wrap gap-3 justify-content-center mt-4'
                gap={3}
              >
                <Button
                  rounded
                  severity='warning'
                  label='Plan Your Visit'
                  onClick={() => (window.location.href = '/community/visiting')}
                />
                <Button
                  rounded
                  severity='secondary'
                  label='Learn About Membership'
                  onClick={() => (window.location.href = '/about/membership')}
                />
              </Stack>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='home-section py-5 bg-light'>
        <Container>
          <Row className='g-4'>
            <Col md={4} sm={6}>
              <Card className='h-100 shadow-sm'>
                <Card.Body className='d-flex flex-column h-100'>
                  <Card.Title>Pray Together</Card.Title>
                  <Card.Text>
                    Join daily minyanim, spirited Shabbat tefillot, and youth
                    programming tailored for every age. Check our davening page for
                    the latest schedule and zmanim.
                  </Card.Text>
                  <Button
                    className='mt-auto'
                    rounded
                    label='View Schedule'
                    severity='info'
                    onClick={() => (window.location.href = '/davening')}
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} sm={6}>
              <Card className='h-100 shadow-sm'>
                <Card.Body className='d-flex flex-column h-100'>
                  <Card.Title>Learn &amp; Grow</Card.Title>
                  <Card.Text>
                    From daily shiurim to family learning and guest scholars, our
                    beit midrash buzzes with opportunities to deepen your Torah
                    journey.
                  </Card.Text>
                  <Button
                    className='mt-auto'
                    rounded
                    label='Learning Opportunities'
                    severity='info'
                    onClick={() => (window.location.href = '/learning')}
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} sm={6}>
              <Card className='h-100 shadow-sm'>
                <Card.Body className='d-flex flex-column h-100'>
                  <Card.Title>Connect in Community</Card.Title>
                  <Card.Text>
                    Experience programs for families, teens, and adults, plus an
                    active chesed network supporting members and visitors alike.
                  </Card.Text>
                  <Button
                    className='mt-auto'
                    rounded
                    label='See Community Life'
                    severity='info'
                    onClick={() => (window.location.href = '/community')}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='home-section py-5'>
        <Container>
          <Row className='align-items-center gy-4'>
            <Col lg={6}>
              <PhotoCarousel />
            </Col>
            <Col lg={6}>
              <h3 className='fw-bold'>Life at Young Israel</h3>
              <p>
                Take a peek at recent simchas, celebrations, and community events.
                Follow our weekly announcements for details on upcoming programs,
                guest speakers, and volunteer opportunities.
              </p>
              <ul className='ps-3'>
                <li>Weekly bulletins with Shabbat and weekday programming</li>
                <li>Family-friendly events and holiday celebrations</li>
                <li>Chesed initiatives supporting members and the broader St. Louis community</li>
              </ul>
              <Button
                className='mt-3'
                rounded
                severity='warning'
                label='Read Announcements'
                onClick={() => document.getElementById('announcement-link')?.click()}
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className='home-section py-5 bg-light'>
        <Container>
          <Row className='g-4'>
            <Col md={6}>
              <Card className='h-100 shadow-sm'>
                <Card.Body className='d-flex flex-column h-100'>
                  <Card.Title>Interested in Membership?</Card.Title>
                  <Card.Text>
                    We offer a welcoming path for new families with an introductory
                    dues rate in the first year. Reach out to schedule a conversation
                    with Rabbi Fink and learn how to get involved.
                  </Card.Text>
                  <Button
                    className='mt-auto'
                    rounded
                    severity='info'
                    label='Contact the Rabbi'
                    onClick={() => (window.location.href = 'tel:13147271880')}
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className='h-100 shadow-sm'>
                <Card.Body className='d-flex flex-column h-100'>
                  <Card.Title>Visiting St. Louis?</Card.Title>
                  <Card.Text>
                    Let us help you enjoy Shabbat with our community. Contact the
                    office for hospitality, meals, or information about the eruv and
                    local amenities.
                  </Card.Text>
                  <Button
                    className='mt-auto'
                    rounded
                    severity='info'
                    label='Email the Office'
                    onClick={() => (window.location.href = 'mailto:info@youngisrael-stl.org')}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home;
